var map = {
	"./1000000435.jpg": "afdb",
	"./1000000435_blue.jpg": "03de",
	"./1000000435_green.jpg": "6144",
	"./1000000435_red.jpg": "b0b3",
	"./1000000438.jpg": "2529",
	"./1000000438_blue.jpg": "c391",
	"./1000000438_green.jpg": "d97c",
	"./1000000438_red.jpg": "3f4e",
	"./1000000439.jpg": "227f",
	"./1000000439_blue.jpg": "e02a",
	"./1000000439_green.jpg": "6e3e",
	"./1000000439_red.jpg": "e609",
	"./1000000466.jpg": "48e9",
	"./1000000466_blue.jpg": "9dda",
	"./1000000466_green.jpg": "50cc",
	"./1000000466_red.jpg": "fb00",
	"./1000000473.jpg": "e519",
	"./1000000473_blue.jpg": "a5a4",
	"./1000000473_green.jpg": "5896",
	"./1000000473_red.jpg": "846c",
	"./1000000491.jpg": "f075",
	"./1000000491_blue.jpg": "71bb",
	"./1000000491_green.jpg": "e5f8",
	"./1000000491_red.jpg": "bae2",
	"./1000000501.jpg": "8cc2",
	"./1000000501_blue.jpg": "6faf",
	"./1000000501_green.jpg": "ca88",
	"./1000000501_red.jpg": "2318",
	"./1000000514.jpg": "a383",
	"./1000000514_blue.jpg": "bf03",
	"./1000000514_green.jpg": "df0d",
	"./1000000514_red.jpg": "a4b9",
	"./1000000534.jpg": "e863",
	"./1000000534_blue.jpg": "cd2e",
	"./1000000534_green.jpg": "c597",
	"./1000000534_red.jpg": "7155",
	"./AI_target.jpg": "552f",
	"./ai_info.jpg": "f112",
	"./ai_scan_dark.jpg": "29c1",
	"./gen_root1.jpg": "55e2",
	"./gen_root2.jpg": "5c4c",
	"./gen_root3.jpg": "11db",
	"./gen_root4.jpg": "5763",
	"./gree_arrow.jpg": "5d37",
	"./lobg.jpg": "5551",
	"./map.jpg": "4554",
	"./miaozhun.jpg": "e16b",
	"./ndvi0.jpg": "c0e1",
	"./ndvi1.jpg": "f6f1",
	"./ndvi2.jpg": "9afa",
	"./ndvi3.jpg": "f2d7",
	"./ndvi4.jpg": "8e4d",
	"./ndvi5.jpg": "469e",
	"./ndvi_10.jpg": "c3f7",
	"./ndvi_11.jpg": "c979",
	"./ndvi_12.jpg": "0ccf",
	"./ndvi_6.jpg": "a3cc",
	"./ndvi_7.jpg": "09a5",
	"./ndvi_8.jpg": "1fba",
	"./ndvi_9.jpg": "e68c",
	"./red_arrow.jpg": "b885",
	"./shibie.jpg": "5c6e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";